// Campus photo for /colleges/iowa-state-university: CC BY-SA 2.0, by Tony Webster from Minneapolis, Minnesota, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABeardshear_Hall_-_Iowa_State_University_(48661099857).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/iowa-state-university/; credited under the photo.
const photo = {
    "slug": "iowa-state-university",
    "alt": "Beardshear Hall, the domed limestone administration building on the Iowa State University campus in Ames, Iowa",
    "src": "/colleges/iowa-state-university/campus-1600.webp",
    "srcSmall": "/colleges/iowa-state-university/campus-800.webp",
    "srcMid": "/colleges/iowa-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/iowa-state-university/og.jpg",
    "title": "Beardshear Hall - Iowa State University (48661099857)",
    "author": "Tony Webster from Minneapolis, Minnesota, United States",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABeardshear_Hall_-_Iowa_State_University_(48661099857).jpg",
    "read": "2026-10-02"
};

export default photo;
